import { render, staticRenderFns } from "./FormatCheckboxGroup.vue?vue&type=template&id=8af90088&"
import script from "./FormatCheckboxGroup.vue?vue&type=script&lang=js&"
export * from "./FormatCheckboxGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports